<template>
  <div>
    <v-autocomplete
      :value="corp"
      :items="filterCorps"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :multiple="isMultiple"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      :disabled="disabled"
      :search-input.sync="filter"
      autocomplete="off"
      :no-filter="true"
      :other="other"
    >
      <template v-slot:selection="data">
        <div v-if="isMultiple">
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
          </div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="clientVendorDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Vendor") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-vendor-create
      @select="selectVendor"
      :showDialog="clientVendorDialog"
    ></z-vendor-create>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";
import common from "@/store/common/module/common";

@Component({
  name: "VendorSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Vendor",
    },
    withSelf: {
      default: false,
    },
    disabled: {
      default: false,
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    other: {
      default: false,
    },
    selectFirst: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class VendorSelect extends (Vue, Themeable) {
  corp = null;
  filter = "";
  clientVendorDialog = false;
  isMultiple = false;

  get loading() {
    return common.loading;
  }

  clear() {
    this.filter = "";
    this.corp = null;
    this.$emit("input", null);
  }

  get filterCorps() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    let corporates = corpService.vendors;
    if (!this.withSelf && this.withSelf !== "") {
      corporates = corporates.slice(1, corporates.length);
    }

    if (filterby == "") {
      return corporates;
    } else {
      const fc = corporates.filter(function (c) {
        return c.name.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (!this.isMultiple) {
      if (newVal) this.corp = newVal;
      if (newVal && newVal.name) {
        this.$emit("input", newVal._id);
        return;
      }
      if (!newVal) this.$emit("input", null);
    } else {
      const response = [];

      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i]._id);
      }

      this.$emit("input", response);
      return;
    }
  }

  async init() {
    this.isMultiple = this.multiple === "" || this.multiple === true;
    await corpService.populateVendors();
    let corporates = corpService.vendors;
    if (this.other == true || this.other == "true") {
      const n = { name: "Other", _id: "null" };
      corporates.push(n);
    }
    if (!this.withSelf && this.withSelf !== "") {
      corporates = corporates.slice(1, corporates.length);
    }
    if (!this.isMultiple) {
      if (this.value) {
        for (let i = 0; i < corporates.length; i++) {
          if (corporates[i]._id === this.value) {
            this.corp = corporates[i];
            break;
          }
        }
      }
    } else {
      this.corp = [];
      if (this.value != null && Array.isArray(this.value)) {
        for (let i = 0; i < corporates.length; i++) {
          if (this.value.filter((e) => e === corporates[i]._id).length > 0) {
            this.corp.push(corporates[i]);
          }
        }
      }
    }
  }

  async selectVendor(newClient) {
    this.clientVendorDialog = false;
    if (newClient != null) {
      await corpService.clearVendors();
      if (Array.isArray(this.corp)) {
        let found = false;
        for (let i = 0; i < this.corp.length; i++) {
          if (this.corp[i]._id === newClient._id) {
            found = true;
          }
        }
        if (!found) this.corp.push(newClient);
        this.changedTo(this.corp);
      } else {
        this.changedTo(newClient);
      }
    }
  }

  async mounted() {
    await this.init();
    this.autoSelect();
  }

  autoSelect() {
    if (this.selectFirst == true) {
      this.changedTo(this.filterCorps[0]);
    }
  }

  selected(val) {
    if (val != null && val._id != null && this.corp != null) {
      if (Array.isArray(this.corp)) {
        for (let i = 0; i < this.corp.length; i++) {
          if (val._id === this.corp[i]._id) {
            return true;
          }
        }
      } else if (this.corp != null && this.corp._id != undefined) {
        if (val._id === this.corp._id) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.corp = null;
    }
    await this.init();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
